import { apiSlice } from "../apiSlice";
import {
  SetMenu,
} from "../setMenuSlice";

export interface MenuApiResponse {
  setMenuList: SetMenu[];
}

export interface DimensionValue {
  id: string;
  dimensionId: string;
  displayName: string;
  description: string;
  displayOrder: number;
  createdAt?: {
    _seconds: number;
    _nanoseconds: number;
  };
  imageUrl?: string;
}

export interface ProductDimension {
  maxValuesAllowed: string;
  id: string;
  customMenuItemTypeId: string;
  displayName: string;
  selectionOrder: number;
  isRequired: boolean;
  createdAt?: {
    _seconds: number;
    _nanoseconds: number;
  };
  dimensionValue?: DimensionValue[]; // Note: API returns 'dimensionValue' (singular)
}

const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_PRODUCTION;

export const setMenuService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMenuListByRestaurantId: builder.query<MenuApiResponse, string>({
      query: (restaurantId) => ({
        url: `https://adminhttps-getsetmenulistbyrestaurantid-${API_BASE_DOMAIN}-uc.a.run.app?restaurantId=${restaurantId}`,
        method: "GET",
      }),
      keepUnusedDataFor: 600, // Moved outside query object
    }),

    // get menu item list
    getMenuListFromCustomerSite: builder.query<any, string>({
      query: (restaurantId) => ({
        url: `https://customersitehttps-getmenulistbyrestaurantid-${API_BASE_DOMAIN}-uc.a.run.app?restaurantId=${restaurantId}`,
        method: "GET",
      }),
      keepUnusedDataFor: 600, // Added caching
    }),

    // get single menu item list from database
    getMenuSingleListFromCustomerSite: builder.query<any, string>({
      query: (restaurantId) => ({
        url: `https://customersitehttps-getmenuitemsbyrestaurantid-${API_BASE_DOMAIN}-uc.a.run.app?restaurantId=${restaurantId}`,
        method: "GET",
      }),
      keepUnusedDataFor: 600, // Moved outside query object
    }),

    // get set menu item list from database
    getMenuSetListFromCustomerSite: builder.query<any, string>({
      query: (restaurantId) => ({
        url: `https://customersitehttps-getsetmenulistbyrestaurantid-${API_BASE_DOMAIN}-uc.a.run.app?restaurantId=${restaurantId}`,
        method: "GET",
      }),
      keepUnusedDataFor: 600, // Moved outside query object
    }),

    // get Custom Menu item from database
    getMenuCustomListFromCustomerSite: builder.query<any, string>({
      query: (restaurantId) => ({
        url: `https://customersitehttps-getcustommenulistbyrestaurantid-${API_BASE_DOMAIN}-uc.a.run.app?restaurantId=${restaurantId}`,
        method: "GET",
      }),
      keepUnusedDataFor: 600, // Moved outside query object
    }),

    // get dimensions by custom menu item type id
    getDimensions: builder.query<ProductDimension[], { restaurantId: string; customMenuItemTypeId: string }>({
      query: ({ restaurantId, customMenuItemTypeId }) => ({
        url: `https://customersitehttps-getdimensions-${API_BASE_DOMAIN}-uc.a.run.app?restaurantId=${restaurantId}&customMenuItemTypeId=${customMenuItemTypeId}`,
        method: "GET",
      }),
      keepUnusedDataFor: 600,
    }),
  }),
});

export const {
  useGetMenuListByRestaurantIdQuery,
  useLazyGetMenuListByRestaurantIdQuery,
  useGetMenuListFromCustomerSiteQuery,
  useGetMenuSingleListFromCustomerSiteQuery,
  useGetMenuSetListFromCustomerSiteQuery,
  useGetMenuCustomListFromCustomerSiteQuery,
  useLazyGetDimensionsQuery
} = setMenuService;
